import NoViewpointsSvg from '^/assets/icons/photo-request/no-viewpoint.svg';
import { useL10n } from '^/hooks';
import theme from '^/theme';
import React from 'react';
import styled from 'styled-components';
import Text from './text';

const Root = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
});

const Title = styled.p({
  fontSize: '20px',
  lineHeight: '150%',
  textAlign: 'center',
  color: theme.colorTokens.textGrayDark,
});

const InfoText = styled.p({
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.colorTokens.disabledGrayDark,
});

export function NoViewpointsInfo() {
  const [l10n] = useL10n();
  return (
    <Root>
      <NoViewpointsSvg />
      <Title>{l10n(Text.emptyState.title)}</Title>
      <InfoText>{l10n(Text.emptyState.infoText)}</InfoText>
    </Root>
  );
}
